export const positionToChain = {
  GK: "goalkeepers",
  LB: "defenders",
  CB: "defenders",
  RB: "defenders",
  LM: "midfielders",
  CAM: "midfielders",
  RM: "midfielders",
  CM: "midfielders",
  CDM: "midfielders",
  LW: "attackers",
  ST: "attackers",
  RW: "attackers",
};

export const uniquePositionScores = {
  GK: 0,
  RB: 1,
  RCB: 2,
  CB: 3,
  LCB: 4,
  LB: 5,
  RM: 6,
  RAM: 7,
  RCM: 8,
  RDM: 9,
  CDM: 10,
  CM: 11,
  CAM: 12,
  LDM: 13,
  LCM: 14,
  LAM: 15,
  LM: 16,
  RW: 17,
  RS: 18,
  ST: 19,
  LS: 20,
  LW: 21,
};
